// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"EG-z","paperCuts":"FG-z"};